import React, { Component, Fragment } from "react";
import Header from "./components/header/Header";
import Footer from "./components/footer/Footer";
import { Route, Switch, withRouter, Redirect } from "react-router-dom";
import Home from "./components/home/Home";
import NotFound from "./components/not-found/NotFound";
import WifiSuccess from "./components/wifi-success/WifiSuccess";
import Support from "./components/support/Support";
import Faqs from "./components/faqs/Faqs";
import About from "./components/about/About";
import Terms from "./components/terms/Terms";
import Privacy from "./components/privacy/Privacy";
import Promotion from "./components/promotion/Promotion";
import Internet from "./components/internet/Internet";
import Press from "./components/press/Press";

import CheckAvailabilityHeader from "./components/header/CheckAvailabilityHeader";
import CheckAvailability from "./components/check-availability/CheckAvailability";
import CheckAvailabilityModal from "./components/check-availability-modal/checkAvailabilityModal";
import ScrollToTop from "./components/scroll-top/ScrollToTop";
import ServiceNotAvailable from "./components/check-availability/ServiceNotAvailable";
import HotSpot from "./components/hotspot/HotSpot";
import GuestHotSpotSuccess from "./components/hotspot/message/Enjoy";
import SubscriberHotSpotSuccess from "./components/hotspot/message/Message";
import FibreOutage from "./components/fibre-outage/FibreOutage";
import axios from "axios";
import GlobalPromo from "./components/global-promo/GlobalPromo";
import { Config } from "./data/config";

class App extends Component {
  constructor() {
    super();
    this.setRefContext = this.setRefContext.bind(this);
    this.message = null;
    this.state = {
      stickyContext: null,
      message: null,
      outageStatus: null,
      promoData: null
    };
  }

  setRefContext(context) {
    this.setState({
      stickyContext: context
    });
  }

  componentDidMount() {
    axios
      .get("/down.file")
      .then(res => {
        const content = res.data;
        this.setState({
          message: content.split(/[\r\n]+/g),
          outageStatus: true
        });
      })
      .catch(error => {
        this.setState({ outageStatus: false });
      });

    axios
      .get(`${Config.frontApiUrl}/onboarding/promo/global`)
      .then(res => {
        this.setState({
          promoData: res.data
        })
      })
  }

  render() {
    const { stickyContext, outageStatus, message, promoData } = this.state;

    return (
      <Fragment>
        {outageStatus !== null && (
          <Fragment>
            {outageStatus ? (
              <FibreOutage message={message} />
            ) : (
                <div className="wrapper" ref={this.setRefContext}>
                  <ScrollToTop>
                    {
                      promoData && <GlobalPromo promoData={promoData}/>
                    }
                    <Switch>
                      <Route
                        path="/"
                        render={props => (
                          <Fragment>
                            <Header
                              stickyContext={stickyContext}
                              inverted={true}
                            />
                            <Home
                              {...props}
                              stickyContext={stickyContext}
                              title="FibreStream Internet"
                              description="FibreStream delivers lightning-fast, incredibly reliable, awesome internet service to residents living in high-rise condo buildings. Only $55 monthly"
                            />{" "}
                            <Footer promoData={promoData ? promoData : null} />
                          </Fragment>
                        )}
                        exact
                      />
                      <Route
                        path="/internet"
                        render={props => (
                          <Fragment>
                            <Header
                              stickyContext={stickyContext}
                              inverted={true}
                            />
                            <Home
                              {...props}
                              stickyContext={stickyContext}
                              title="FibreStream Internet"
                              description="FibreStream delivers lightning-fast, incredibly reliable, awesome internet service to residents living in high-rise condo buildings. Only $55 monthly"
                            />{" "}
                            <Footer promoData={promoData ? promoData : null} />
                          </Fragment>
                        )}
                        exact
                      />
                      <Route
                        path="/packages"
                        render={props => (
                          <Fragment>
                            <Header
                              stickyContext={stickyContext}
                              inverted={true}
                            />
                            <Home
                              {...props}
                              stickyContext={stickyContext}
                              title="FibreStream Internet"
                              description="FibreStream delivers lightning-fast, incredibly reliable, awesome internet service to residents living in high-rise condo buildings. Only $55 monthly"
                            />{" "}
                            <Footer promoData={promoData ? promoData : null} />
                          </Fragment>
                        )}
                        exact
                      />
                      <Route
                        path="/check"
                        render={props => (
                          <Fragment>
                            <CheckAvailabilityModal
                              open={true}
                              title="Availability"
                              description="Check if your address is FibreReady"
                            />
                          </Fragment>
                        )}
                        exact
                      />
                      <Route
                        path="/locations"
                        render={props => (
                          <Fragment>
                            <Header
                              stickyContext={stickyContext}
                              inverted={true}
                            />
                            <Home
                              {...props}
                              openLocation={true}
                              stickyContext={stickyContext}
                              title="FibreStream Internet"
                              description="FibreStream delivers lightning-fast, incredibly reliable, awesome internet service to residents living in high-rise condo buildings. Only $55 monthly"
                            />{" "}
                            <Footer promoData={promoData ? promoData : null} />
                          </Fragment>
                        )}
                        exact
                      />
                      <Route
                        path="/support"
                        render={() => (
                          <Fragment>
                            <Header
                              headerType={"white"}
                              stickyContext={stickyContext}
                            />
                            <Support
                              title="Support"
                              description="We're here to help"
                            />
                            <Footer promoData={promoData ? promoData : null} />
                          </Fragment>
                        )}
                        exact
                      />
                      <Route
                        path="/faqs"
                        render={() => (
                          <Fragment>
                            <Header
                              headerType={"white"}
                              stickyContext={stickyContext}
                            />
                            <Faqs
                              title="FibreStream FAQs"
                              description="View our FAQs"
                            />
                            <Footer promoData={promoData ? promoData : null} />
                          </Fragment>
                        )}
                        exact
                      />
                      <Route
                        path="/terms"
                        render={() => (
                          <Fragment>
                            <Header
                              headerType={"white"}
                              stickyContext={stickyContext}
                            />
                            <Terms
                              title="FibreStream Terms"
                              description="See our terms and conditions"
                            />
                            <Footer footerType={"white"} promoData={promoData ? promoData : null} />
                          </Fragment>
                        )}
                        exact
                      />
                      <Route
                        path="/privacy"
                        render={() => (
                          <Fragment>
                            <Header
                              headerType={"white"}
                              stickyContext={stickyContext}
                            />
                            <Privacy
                              title="FibreStream Privacy Policy"
                              description="Privacy Policy"
                            />
                            <Footer footerType={"white"} promoData={promoData ? promoData : null} />
                          </Fragment>
                        )}
                        exact
                      />
                      <Route
                        path="/about"
                        render={() => (
                          <Fragment>
                            <Header
                              headerType={"white"}
                              inverted={true}
                              stickyContext={stickyContext}
                            />
                            <About
                              title="FibreStream About"
                              description="Learn more about FibreStream"
                            />
                            <Footer promoData={promoData ? promoData : null} />
                          </Fragment>
                        )}
                        exact
                      />
                      <Route
                        path="/promotion/:code"
                        exact
                        render={() => (
                          <Fragment>
                            <Header
                              headerType={"white"}
                              inverted={true}
                              stickyContext={stickyContext}
                            />
                            <Promotion />
                            <Footer footerFormType={"signUpFooter"} promoData={promoData ? promoData : null} />
                          </Fragment>
                        )}
                      />
                      <Route
                        path="/check-availability"
                        render={() => (
                          <Fragment>
                            <CheckAvailabilityHeader
                              stickyContext={stickyContext}
                            />
                            <CheckAvailability
                              title="FibreStream Internet"
                              description="Check if FibreStream is available at your building address"
                            />
                          </Fragment>
                        )}
                        exact
                      />
                      <Route
                        path="/request-fibrestream"
                        render={() => (
                          <Fragment>
                            <CheckAvailabilityHeader
                              stickyContext={stickyContext}
                            />
                            <ServiceNotAvailable
                              title="FibreStream Request"
                              description="You can request FibreStream if your building is compatible."
                            />
                          </Fragment>
                        )}
                        exact
                      />
                      <Route
                        path="/signup"
                        render={() => <Redirect to="/check-availability" />}
                        exact
                      />
                      <Route
                        path="/internet"
                        render={() => <Redirect to="/" />}
                        exact
                      />
                      <Route
                        path="/myaccount"
                        component={() =>
                          window.location.replace(
                            "https://my.freshbooks.com/"
                          )
                        }
                        exact
                      />
                      <Route
                        path="/wifi/success"
                        render={() => (
                          <Fragment>
                            <Header
                              stickyContext={stickyContext}
                              headerType={"white"}
                              inverted={true}
                            />
                            <WifiSuccess
                              title="FibreStream Wi-Fi"
                              description="Enjoy free Wi-Fi"
                            />
                          </Fragment>
                        )}
                        exact
                      />
                      <Route path="/hotspot/login" component={HotSpot} exact />
                      <Route
                        path="/hotspot/success/guest"
                        component={GuestHotSpotSuccess}
                        exact
                      />
                      <Route
                        path="/hotspot/success/subscriber"
                        component={SubscriberHotSpotSuccess}
                        exact
                      />
                      <Route
                        path="/internet-5000"
                        render={() => (
                          <Fragment>
                            <Header
                              headerType={"white"}
                              inverted={true}
                              stickyContext={stickyContext}
                            />
                            <Internet
                              title="5000 Mbps"
                              description="Introducing the fastest Internet in Canada"
                            />
                            <Footer promoData={promoData ? promoData : null} />
                          </Fragment>
                        )}
                        exact
                      />
                      <Route
                        path="/press"
                        render={() => (
                          <Fragment>
                            <Header
                              headerType={"white"}
                              stickyContext={stickyContext}
                            />
                            <Press
                              title="FibreStream Press"
                              description="Press"
                            />
                            <Footer promoData={promoData ? promoData : null} />
                          </Fragment>
                        )}
                        exact
                      />
                      <Route
                        status={404}
                        render={() => (
                          <Fragment>
                            <Header stickyContext={stickyContext} /> <NotFound />
                          </Fragment>
                        )}
                      />
                    </Switch>
                  </ScrollToTop>
                </div>
              )}
          </Fragment>
        )}
      </Fragment>
    );
  }
}

export default withRouter(App);



// WEBPACK FOOTER //
// ./src/App.js